import { render, staticRenderFns } from "./TikTokIcon.vue?vue&type=template&id=76e9d162&scoped=true&"
import script from "./TikTokIcon.vue?vue&type=script&lang=js&"
export * from "./TikTokIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9d162",
  null
  
)

export default component.exports